document.addEventListener('DOMContentLoaded', () => {
  initBirkenstockCommunityForm();
});

function initBirkenstockCommunityForm() {
  initBlurValidation();
  initPreferenceToggle();
  initGenderToggle();
  initSelectBlurValidation();
  initSubmitButtonLogic();
}

/* =====================================================
   BLUR VALIDATION FUNCTION (STEP 1)
===================================================== */
const fieldValidators = {
    community_fullName: value =>  /^[A-Za-z]+(?:\s+[A-Za-z]+)+$/.test(value),

    community_mobile: value => /^\d{10}$/.test(value),

    community_city: value => /^[A-Za-z\s-]{2,}$/.test(value),

    community_email: value =>
      /^[A-Za-z0-9]+([._+-]?[A-Za-z0-9]+)*@[A-Za-z0-9-]+(\.[A-Za-z]{2,})+$/.test(value),

    community_dob: (value, field) => {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;

      const [year, month, day] = value.split('-').map(Number);

      // Create date in local timezone (Safari-safe)
      const selectedDate = new Date(year, month - 1, day);

      // Normalize today to midnight
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return (
        selectedDate instanceof Date &&
        !isNaN(selectedDate.getTime()) &&
        selectedDate <= today
      );
    }

  };
  function toggleError(fieldId, isValid) {
  const errorEl = document.getElementById(`${fieldId}Error`);
  if (!errorEl) return;

  isValid
    ? errorEl.classList.add('hidden')
    : errorEl.classList.remove('hidden');
}


  function validateAndToggleError(field) {
  if (!field.id) return;

  const validator = fieldValidators[field.id];
  if (!validator) return;

  const value = field.value.trim();
  const isValid = validator(value, field);

  toggleError(field.id, isValid);
}

function initBlurValidation() {
  const form = document.getElementById('birkenstock-profile-form');
  if (!form) return;

  const fields = form.querySelectorAll('input, textarea');

  fields.forEach(field => {
    if (!field.id) return;
    field.addEventListener('blur', () => validateAndToggleError(field));
    field.addEventListener('input', () => validateAndToggleError(field));

  });
  const cityField = document.getElementById('community_city');

  if (cityField) {
    cityField.addEventListener('input', () => {
      cityField.value = cityField.value.replace(/[^A-Za-z\s-]/g, '');
    });
  }
}
/* =====================================================
   PREFERRED STYLES & COLOURS (STEP 2)
===================================================== */
function initPreferenceToggle() {

  ['community-style-options', 'community-colour-options'].forEach(groupId => {

    const group = document.getElementById(groupId);
    if (!group) return;

    const otherPicker = document.getElementById('community-other-colour-picker');
    const otherInput = document.getElementById('community_custom_colour');

    group.querySelectorAll('.community-option').forEach(button => {

      button.addEventListener('click', () => {

        button.classList.toggle('checked');

      if (groupId === 'community-colour-options') {

        const isOther = button.classList.contains('community-other-colour');

        if (isOther) {
          const isChecked = button.classList.contains('checked');

          if (isChecked) {
            otherPicker?.classList.remove('hidden');
          } else {
            otherPicker?.classList.add('hidden');

            if (otherInput) {
              otherInput.value = '';
              button.dataset.value = 'Other';
            }
          }
        }

      }

        const errorEl = group.parentElement.querySelector('.community-form-error-message');
        errorEl?.classList.add('hidden');

        document.getElementById('community_formErrorMessage')?.classList.add('hidden');

      });

    });

    if (otherInput) {
      otherInput.addEventListener('input', () => {

        const otherBtn = group.querySelector('.community-other-colour');
        if (!otherBtn) return;

        const selectedColor = otherInput.value;

        otherBtn.dataset.value = selectedColor;

      });
    }

  });

}
function initGenderToggle() {
  const genderGroup = document.getElementById('community_gender');
  if (!genderGroup) return;

  const buttons = genderGroup.querySelectorAll('.gender-option');
  const errorEl = document.getElementById('community_genderError');

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      // Remove checked from all
      buttons.forEach(b => b.classList.remove('checked'));

      // Add checked to selected
      button.classList.add('checked');

      // Hide error
      errorEl?.classList.add('hidden');

      // Hide form-level error
      document
        .getElementById('community_formErrorMessage')
        ?.classList.add('hidden');
    });
  });
}


/* =====================================================
   SELECT BLUR VALIDATION (STEP 3)
===================================================== */
function initSelectBlurValidation() {
  [
    { fieldId: 'community_daily_usage', errorId: 'community_daily_usageError' },
    { fieldId: 'community_foot_type', errorId: 'community_foot_typeError' }
  ].forEach(({ fieldId, errorId }) => {
    const selectEl = document.getElementById(fieldId);
    const errorEl = document.getElementById(errorId);
    if (!selectEl || !errorEl) return;

    const defaultOption = selectEl.querySelector('option[value="none"]');

    selectEl.addEventListener('blur', () => {
      if (selectEl.value === 'none') {
        errorEl.classList.remove('hidden');
      }
    });

    selectEl.addEventListener('change', () => {
      selectEl.querySelectorAll('option').forEach(opt =>
        opt.removeAttribute('selected')
      );

      const selectedOption = selectEl.querySelector(
        `option[value="${CSS.escape(selectEl.value)}"]`
      );
      selectedOption?.setAttribute('selected', 'selected');

      if (defaultOption && selectEl.value !== 'none') {
        defaultOption.disabled = true;
      }

      selectEl.dataset.value = selectEl.value;

      selectEl.value !== 'none'
        ? errorEl.classList.add('hidden')
        : errorEl.classList.remove('hidden');
    });
  });
}

/* =====================================================
   SUBMIT BUTTON, LOADER & SUCCESS (STEP 4 – FIXED)
===================================================== */
  function resetSelectField(selectId) {
    const selectEl = document.getElementById(selectId);
    if (!selectEl) return;

    const defaultOption = selectEl.querySelector('option[value="none"]');

    if (defaultOption) {
      defaultOption.disabled = false;
    }

    selectEl.value = 'none';
    selectEl.dataset.value = '';

    document
      .getElementById(`${selectId}Error`)
      ?.classList.add('hidden');
  }

function initSubmitButtonLogic() {
  const form = document.getElementById('birkenstock-profile-form');
  const submitBtn = document.getElementById('community_submit_button');
  const submitText = submitBtn?.querySelector('.community-submit-text');
  const loader = submitBtn?.querySelector('.loading-overlay');

  const formError = document.getElementById('community_formErrorMessage');
  const formSuccess = document.getElementById('community_formSuccessMessage');

  if (!form || !submitBtn) return;

  const hideSuccess = () => {
    formSuccess?.classList.add('hidden');
  };

  form.addEventListener('click', hideSuccess);
  form.addEventListener('input', hideSuccess);



  const SCRIPT_URL =
    'https://script.google.com/macros/s/AKfycbw-5owbSsXrMjAppM4yP3RHN_11WDtGCkhCKGC5pgyOZwT7Qh-C8Tcjl4J06UTCdM2L_Q/exec';

  const fields = {
    gender: document.getElementById('community_gender'),
    fullName: document.getElementById('community_fullName'),
    dob: document.getElementById('community_dob'),
    city: document.getElementById('community_city'),
    email: document.getElementById('community_email'),
    mobile: document.getElementById('community_mobile'),
    usage: document.getElementById('community_daily_usage'),
    footType: document.getElementById('community_foot_type'),
    styles: document.getElementById('community-style-options'),
    colours: document.getElementById('community-colour-options')
  };


  Object.values(fields).forEach(field => {
    if (!field) return;
    if (field.tagName === 'DIV') {
      field.dataset.values = '[]';
    } else {
      field.dataset.value = field.value || '';
    }
    const eventType =
      field.tagName === 'DIV' ? 'click' :
      field.tagName === 'SELECT' ? 'change' :
      'input';

    field.addEventListener(eventType, () => {
      formError?.classList.add('hidden');
    });
  });

  function showLoader() {
    submitBtn.disabled = true;
    loader.style.opacity = '1';
    submitText.style.opacity = '0';
  }

  function hideLoader() {
    loader.style.opacity = '0';
    submitText.style.opacity = '1';
  }

  function forceValidateAllFields() {
    let valid = true; 

    if (fields.gender && !fields.gender.querySelector('.checked')) {
      valid = false;
   }

    Object.values(fields).forEach(field => {
      if (!field) return;
  
      if (field.tagName === 'DIV') {
        if (![...field.querySelectorAll('.checked')].length) {
          valid = false;
        }
        return;
      }

      if (field.tagName === 'SELECT') {
        if (field.value === 'none') {
          valid = false;
        }
        return;
      }

      const value = field.value.trim();
      const validator = fieldValidators[field.id];

      if (!validator || !validator(value, field)) {
        valid = false;
      }
    });

    return valid;
  }
  function showFieldErrors() {
    let hasError = false;

    if (fields.gender && !fields.gender.querySelector('.checked')) {
      document
        .getElementById('community_genderError')
        ?.classList.remove('hidden');
      hasError = true;
    }

    Object.values(fields).forEach(field => {
      if (!field) return;

      if (field.tagName === 'DIV') {
        if (![...field.querySelectorAll('.checked')].length) {
          field.parentElement
            ?.querySelector('.community-form-error-message')
            ?.classList.remove('hidden');
          hasError = true;
        }
        return;
      }

      if (field.tagName === 'SELECT') {
        if (field.value === 'none') {
          document
            .getElementById(`${field.id}Error`)
            ?.classList.remove('hidden');
          hasError = true;
        }
        return;
      }

      const value = field.value.trim();
      const validator = fieldValidators[field.id];

      if (!validator || !validator(value, field)) {
        document
          .getElementById(`${field.id}Error`)
          ?.classList.remove('hidden');
        hasError = true;
      }
    });

    if (hasError) {
      formError?.classList.remove('hidden');
    }

    return hasError;
  }

  function parseDOB(dobString) {
    if (!dobString) return null;
    const [year, month, day] = dobString.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  form.addEventListener('submit', async e => {
    e.preventDefault();

    formError?.classList.add('hidden');
    formSuccess?.classList.add('hidden');

    const isValid = forceValidateAllFields();
    const hasErrors = showFieldErrors();

    if (!isValid || hasErrors) {
      return;
    }


    showLoader();

    const payload = {
      timestamp: new Date().toISOString(),
      gender: fields.gender.querySelector('.checked')?.dataset.value || '',
      fullName: fields.fullName.value.trim(),
      dob: fields.dob.value,
      city: fields.city.value.trim() || '',
      email: fields.email.value.trim(),
      mobile: fields.mobile.value.trim(),
      preferredStyles: [...fields.styles.querySelectorAll('.checked')]
        .map(b => b.dataset.value)
        .join(', '),
      preferredColours: [...fields.colours.querySelectorAll('.checked')]
        .map(b => b.dataset.value)
        .join(', '),
      dailyUsage: fields.usage.value === 'none' ? '' : fields.usage?.value || '',
      footType: fields.footType.value === 'none' ? '' : fields.footType?.value || ''
    };

    try {
      const formData = new FormData();
      Object.keys(payload).forEach(k => formData.append(k, payload[k]));

      const response = await fetch(SCRIPT_URL, {
        method: 'POST',
        body: formData
      });

      const text = await response.text();
      let result;

      try {
        result = JSON.parse(text);
      } catch {
        result = { success: true };
      }
      hideLoader();

      if (!result.success) {
        formError.textContent = result.message || 'Submission failed.';
        formError.classList.remove('hidden');
        submitBtn.disabled = false;
        return;
      }

      formSuccess?.classList.remove('hidden');
      formError?.classList.add('hidden');
      form.reset();
      document.getElementById('community-other-colour-picker')?.classList.add('hidden');
      const otherBtn = document.querySelector('.community-other-colour');
      if(otherBtn){
        otherBtn.dataset.value = 'Other';
      }

      const otherInput = document.getElementById('community_custom_colour');
      if(otherInput){
        otherInput.value = '';
      }

      submitBtn.disabled = false;

      Object.values(fields).forEach(field => {
        if (field?.tagName === 'DIV') {
          field.querySelectorAll('.checked')
            .forEach(el => el.classList.remove('checked'));
        }
      });

      resetSelectField('community_daily_usage');
      resetSelectField('community_foot_type');

      // ===== MoEngage Tracking (Post Successful Submission) =====
      if (payload.email) {
        const nameParts = payload.fullName.trim().split(/\s+/);
        const firstName = nameParts.shift();
        const lastName = nameParts.join(' ');
        const dobDate = parseDOB(payload.dob);

        if (typeof Moengage !== "undefined"){
          // Basic user details
          Moengage.add_first_name(firstName);
          Moengage.add_last_name(lastName);
          Moengage.add_email(payload.email);
          Moengage.add_mobile(payload.mobile);
          Moengage.add_gender(payload.gender);
          if (dobDate) {
            Moengage.add_birthday(dobDate);
          }

          // Custom user attributes
          Moengage.add_user_attribute("City", payload.city);
          Moengage.add_user_attribute("Date of Birth", payload.dob);
          Moengage.add_user_attribute("Daily Usage", payload.dailyUsage);
          Moengage.add_user_attribute("Foot Type", payload.footType);
          Moengage.add_user_attribute("Preferred Styles", payload.preferredStyles);
          Moengage.add_user_attribute("Preferred Colours", payload.preferredColours);

          // Track event
          Moengage.track_event("Community Form Submitted", {
            "User ID": payload.email,
            "First Name": firstName,
            "Last Name": lastName,
            "Gender": payload.gender,
            "Email Id": payload.email,
            "Mobile Number": payload.mobile,
            "City": payload.city,
            "Date of Birth": payload.dob,
            "Daily Usage": payload.dailyUsage,
            "Foot Type": payload.footType,
            "Preferred Styles": payload.preferredStyles,
            "Preferred Colours": payload.preferredColours,
            "Device": navigator.userAgent,
            "Source": "Shopify",
            "Brand": "Birkenstock"
          });
        }
      }

    } catch (err) {
      hideLoader();
      formError.textContent =
        'Unable to connect. Please check your network and try again.';
      formError.classList.remove('hidden');
      submitBtn.disabled = false;
    }
  });
}
